var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DataTable',{attrs:{"rowKeys":['id'],"rows":_vm.conductorApis,"actions":[
      {
        name: 'workflowList',
        label: 'Go',
        params: { id: 'conductorApiId' }
      }
    ],"columns":[
      { name: 'id', type: 'text' },
      { name: 'url', type: 'text' },
      { name: 'readOnly', type: 'boolean' },
      { name: 'color', type: 'color' }
    ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }